// Format & parse angka dipusatkan. Tampilan selalu en-US; parser nerima
// gaya en-US maupun id-ID biar copas dari Excel manapun kebaca.

// Angka -> string tampilan. Non-angka balikin '-'.
export function formatNum(value, decimals = 2, grouping = true) {
  // Number('') dan Number(null) itu 0, bukan NaN — makanya dicek duluan.
  if (value === null || value === undefined || value === '') return '-';
  const num = Number(value);
  if (!Number.isFinite(num)) return '-';
  return num.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
    useGrouping: grouping,
  });
}

// Sama kayak formatNum tapi kosong/null balik '' (bukan '-') dan nilai yang bukan
// angka dibalikin apa adanya. Dipakai sel tabel ROB & bunkering.
export function formatNumOrBlank(value, decimals = 1) {
  if (value === null || typeof value === 'undefined') return '';
  const num = Number(value);
  if (Number.isNaN(num)) return value;
  return formatNum(num, decimals);
}

// Sengaja parseFloat, bukan parseNum: '12abc' harus kebaca 12 kayak perilaku lama.
// Nilai yang gak kebaca dibalikin apa adanya. Dipakai ringkasan bunkering.
export function formatNumOrRaw(num, decimals = 2) {
  const number = parseFloat(num);
  if (Number.isNaN(number)) return num;
  return formatNum(number, decimals);
}

// Teks -> Number, NaN kalau gak kebaca.
export function parseNum(text) {
  if (typeof text === 'number') return Number.isFinite(text) ? text : NaN;
  if (text === null || text === undefined) return NaN;

  // \s udah nyakup NBSP & narrow-NBSP dari copasan web.
  const cleaned = String(text).replace(/\s/g, '').replace(/[^0-9.,+-]/g, '');
  if (!/\d/.test(cleaned)) return NaN;

  const sign = cleaned.startsWith('-') ? -1 : 1;
  const body = cleaned.replace(/^[+-]/, '');
  const dots = (body.match(/\./g) || []).length;
  const commas = (body.match(/,/g) || []).length;

  let decimalSep = '';
  if (dots && commas) {
    decimalSep = body.lastIndexOf('.') > body.lastIndexOf(',') ? '.' : ',';
  } else if (dots + commas === 1) {
    const sep = dots ? '.' : ',';
    const [head, tail] = body.split(sep);
    // 3 digit di belakang itu ambigu; baca sebagai ribuan kecuali bagian bulatnya 0.
    const isGrouping = tail.length === 3 && head !== '0' && head !== '';
    decimalSep = isGrouping ? '' : sep;
  }

  let normalized;
  if (decimalSep) {
    const other = decimalSep === '.' ? ',' : '.';
    normalized = body.split(other).join('').replace(decimalSep, '.');
  } else {
    normalized = body.replace(/[.,]/g, '');
  }

  const num = Number(normalized);
  return Number.isFinite(num) ? sign * num : NaN;
}

// Buat sel Excel: jadiin Number cuma kalau isinya emang satu token angka.
// Koordinat "lat lng", durasi, dateTime, dan '-' tetep teks.
export function numericCell(value) {
  if (typeof value === 'number') return value;
  const text = String(value === null || value === undefined ? '' : value).trim();
  if (!/^[+-]?[\d.,]+$/.test(text)) return value;
  const num = parseNum(text);
  return Number.isFinite(num) ? num : value;
}
